const link_calendar = document.querySelectorAll('.link_calendar');
const addToCal = document.querySelectorAll('.addToCalendar');

if (addToCal) {
    addToCal.forEach(function (add) {
        add.onclick = function () {
            var ele = add.closest('.event-details__link').lastElementChild;
            if (ele.classList.contains('open')) {
                ele.classList.remove('open');
            }
            else {
                ele.classList.add('open');
            }
        };
    });

}
if (link_calendar) {
    link_calendar.forEach(function (link) {
        link.addEventListener('click', (e) => {
            link.closest('.list-links').classList.remove('open');
        });
    });
}

